import { useState, useEffect } from 'react';
import { Eye, Shield, Search, Clock, Award, Users, ChevronRight, Mail, Phone, MapPin } from 'lucide-react';
import './App.css';
import CaseStudies from './Components/CaseStudies';
import PricingPlans from './Components/PricingPlans';
import FAQSection from './Components/FAQSection';
import logodd from "./logo89.jpg"; // <-- your logo image path


function App() {
  const [scrollY, setScrollY] = useState(0);
  const [activeCase, setActiveCase] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveCase((prev) => (prev + 1) % 3);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const services = [
    {
      icon: <Search size={40} />,
      title: "Corporate Investigations",
      description: "Thorough background checks, due diligence, and corporate fraud investigations with discretion and precision."
    },
    {
      icon: <Shield size={40} />,
      title: "Asset Protection",
      description: "Safeguard your assets with comprehensive security assessments and surveillance operations."
    },
    {
      icon: <Eye size={40} />,
      title: "Surveillance Services",
      description: "Advanced surveillance technology and expert field operatives for complex monitoring cases."
    },
    {
      icon: <Users size={40} />,
      title: "Personal Investigations",
      description: "Sensitive personal matters handled with utmost confidentiality and professional expertise."
    }
  ];

  const cases = [
    { number: "250+", label: "Cases Solved" },
    { number: "98%", label: "Success Rate" },
    { number: "15+", label: "Years Experience" }
  ];

  const testimonials = [
    {
      text: "Their attention to detail and professionalism exceeded all expectations. They uncovered critical evidence that changed everything.",
      author: "David Richardson",
      role: "CEO, Tech Innovations"
    },
    {
      text: "Discreet, efficient, and incredibly thorough. The team's expertise in corporate investigations is unmatched.",
      author: "Sarah Mitchell",
      role: "Legal Director"
    },
    {
      text: "When we needed answers, they delivered results. Their surveillance techniques are cutting-edge and highly effective.",
      author: "James Cooper",
      role: "Private Client"
    }
  ];

  return (
    <div className="app">
      {/* Navigation */}
      <nav className="navbar" style={{ transform: `translateY(${scrollY > 50 ? '-100%' : '0'})` }}>
        <div className="nav-container" style={{height : "70px"}} >
          <div className="logo">
            <img
            src={logodd}
            alt="GR Mushroom Farms Logo"
            style={{ width: "50px", height: "50px", objectFit: "contain" }}></img>
            <span style={{fontSize :"21px"}}>DEE DETECTIVES</span>
          </div>
          <div className="nav-links">
            <a href="#services">Services</a>
            <a href="#about">About</a>
            <a href="#cases">Cases</a>
            <a href="#contact" className="contact-btn">Contact Us</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-bg" style={{ transform: `translateY(${scrollY * 0.5}px)` }}></div>
        <div className="hero-content">
          <div className="hero-badge">Professional Investigation Services</div>
          <h1 className="hero-title">
            Uncovering Truth<br />
            <span className="gradient-text">With Precision</span>
          </h1>
          <p className="hero-subtitle">
            A premium detective service combining innovation with investigative excellence.
            When you need answers, we deliver results.
          </p>
          <div className="hero-buttons">
            <button className="btn-primary">
              Start Investigation <ChevronRight size={20} />
            </button>
            <button className="btn-secondary">
              Our Services
            </button>
          </div>
          <div className="hero-stats">
            {cases.map((stat, index) => (
              <div key={index} className="stat-card" style={{ animationDelay: `${index * 0.2}s` }}>
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="hero-decoration"></div>
      </section>

      {/* Services Section */}
      <section id="services" className="services-section">
        <div className="section-container">
          <div className="section-header">
            <div className="section-badge">Our Expertise</div>
            <h2 className="section-title">Specialized Investigation Services</h2>
            <p className="section-subtitle">
            Strategic and confidential investigative solutions tailored to your exact needs.
            </p>
          </div>
          <div className="services-grid">
            {services.map((service, index) => (
              <div
                key={index}
                className="service-card"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <div className="service-icon">{service.icon}</div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <button className="service-link">
                  Learn More <ChevronRight size={16} />
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about-section">
        <div className="section-container">
          <div className="about-grid">
            <div className="about-image">
              <div className="image-frame">
                <Eye size={120} className="about-icon" />
              </div>
              <div className="experience-badge">
                <Award size={24} />
                <div>
                  <div className="badge-number">15+</div>
                  <div className="badge-text">Years Experience</div>
                </div>
              </div>
            </div>
            <div className="about-content">
              <div className="section-badge">About Dee</div>
              <h2 className="section-title">Your Trusted Investigation Partner</h2>
                <h2 className="section-title">Private Investigation Services</h2>
              <p className="about-text">
               Founded in 2016, Dee Detectives has become the most trusted name in private investigation. Our intelligence specialists brings wide range of professional investigation services with complete confidentiality and integrity.
              </p>
              <p className="about-text">
               We combine reliable investigative methodology to deliver comprehensive result
              </p>
              <div className="about-features">
                <div className="feature-item">
                  <Clock size={24} />
                  <div>
                    <h4>24/7 Availability</h4>
                    <p>Round-the-clock support for urgent cases</p>
                  </div>
                </div>
                <div className="feature-item">
                  <Shield size={24} />
                  <div>
                    <h4>Confidential Service</h4>
                    <p>Complete discretion guaranteed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <div className="section-container">
          <div className="section-header">
            <div className="section-badge">Client Success Stories</div>
            <h2 className="section-title">What Our Clients Say</h2>
          </div>
          <div className="testimonials-slider">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className={`testimonial-card ${index === activeCase ? 'active' : ''}`}
              >
                <div className="quote-mark">"</div>
                <p className="testimonial-text">{testimonial.text}</p>
                <div className="testimonial-author">
                  <div className="author-avatar">{testimonial.author.charAt(0)}</div>
                  <div>
                    <div className="author-name">{testimonial.author}</div>
                    <div className="author-role">{testimonial.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="slider-dots">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === activeCase ? 'active' : ''}`}
                onClick={() => setActiveCase(index)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Case Studies */}
      <CaseStudies />

      {/* Pricing Plans */}
      <PricingPlans />

      {/* FAQ Section */}
      <FAQSection />

      {/* Contact Section */}
      <section id="contact" className="contact-section">
        <div className="section-container">
          <div className="contact-grid">
            <div className="contact-info">
              <div className="section-badge">Get In Touch</div>
              <h2 className="section-title">Start Your Investigation</h2>
              <p className="contact-description">
                Every case begins with a confidential consultation. Reach out to discuss your needs
                and discover how we can help.
              </p>
              <div className="contact-details">
                <div className="contact-item">
                  <Phone size={24} />
                  <div>
                    <div className="contact-label">Phone</div>
                    <div className="contact-value">+91-9600054555</div>
                  </div>
                </div>
                <div className="contact-item">
                  <Mail size={24} />
                  <div>
                    <div className="contact-label">Email</div>
                    <div className="contact-value">DeeDetectives@gmail.com</div>
                  </div>
                </div>
                <div className="contact-item">
                  <MapPin size={24} />
                  <div>
                    <div className="contact-label">Office</div>
                    <div className="contact-value">No: 12 B, First Floor, Lock Street, Kotturpuram, Chennai - 600085</div>
                  </div>
                </div>
              </div>
            </div>
            <form className="contact-form">
              <div className="form-group">
                <label>Full Name</label>
                <input type="text" placeholder="John Doe" />
              </div>
              <div className="form-group">
                <label>Email Address</label>
                <input type="email" placeholder="john@example.com" />
              </div>
              <div className="form-group">
                <label>Phone Number</label>
                <input type="tel" placeholder="+1 (555) 000-0000" />
              </div>
              <div className="form-group">
                <label>Case Description</label>
                <textarea rows={4} placeholder="Briefly describe your case..."></textarea>
              </div>
              <button type="submit" className="btn-primary full-width"  onClick={() => window.open("https://wa.me/919600054555", "_blank")}>
                Request Consultation
              </button>
              <p className="form-note">All inquiries are handled with strict confidentiality</p>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="section-container">
          <div className="footer-content">
            <div className="footer-brand">
                <img
            src={logodd}
            alt="GR Mushroom Farms Logo"
            style={{ width: "50px", height: "50px", objectFit: "contain" }}></img>
              <span>Dee Detectives</span>
            </div>
            <p className="footer-text">
              Professional detective services you can trust. Licensed, bonded, and insured.
            </p>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Dee Detective Agency. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
